<div class="container-fluid h-100">
  <div class="row h-100">
    <div class="col-2 overflow-auto" style="height: calc(100vh - 56px);">

      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th>id</th>
          <th>whitelist</th>
          <th>actions</th>
        </tr>
        </thead>
        <tbody>
          @for (filter of filters; track filter.id) {
            <tr>
              <td>{{filter.id}}</td>
              <td>{{filter.whiteList}}</td>
              <td>
                <button type="button" class="btn btn-sm btn-primary" (click)="deleteFilter(filter)">x</button>
              </td>
            </tr>
          }
        </tbody>
      </table>


    </div>
    <div class="col-10 overflow-auto" style="height: calc(100vh - 56px);">

      <div>


      <table class="table table-sm table-hover">
        <thead>
        <tr>
          <th class="ellipsis-lg">url</th>
          <th class="ellipsis">title</th>
          <th>lastVisitDate</th>
          <th>visitCount</th>
          <th>hidden</th>
          <th class="ellipsis">image</th>
          <th class="ellipsis">description</th>
          <th>id</th>
          <th>hostname</th>
          <th class="ellipsis">filename</th>
          <th>sqliteId</th>
          <th>createdAt</th>
          <th>updatedAt</th>
          <th>ack</th>
          <th>actions</th>
        </tr>
        </thead>
        <tbody>
          @for (mp of mozPlaces.content; track mp.id) {
            <tr>
              <td class="ellipsis-lg"><a target="_blank" [href]="mp.url" [title]="mp.url">{{mp.url}}</a></td>
              <td class="ellipsis" [title]="mp.title">{{mp.title}}</td>
              <td>{{mp.lastVisitDate}}</td>
              <td>{{mp.visitCount}}</td>
              <td>{{mp.hidden}}</td>
              <td class="ellipsis" [title]="mp.previewImageUrl"><a target="_blank" [href]="mp.previewImageUrl">{{mp.previewImageUrl}}</a></td>
              <td class="ellipsis" [title]="mp.description">{{mp.description}}</td>
              <td>{{mp.id}}</td>
              <td>{{mp.hostname}}</td>
              <td class="ellipsis" [title]="mp.filename">{{mp.filename}}</td>
              <td>{{mp.sqliteId}}</td>
              <td>{{mp.createdAt}}</td>
              <td>{{mp.updatedAt}}</td>
              <td>
                <button type="button" class="btn btn-sm btn-primary" (click)="manualAck(mp)">ack</button>
              </td>
              <td>
                <button type="button" class="btn btn-sm btn-primary" (click)="addDomainFilter(mp)">whitelist {{urlToDomainLike(mp.url)}}</button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      </div>

    </div>
  </div>
</div>


